import React from 'react';
import { withGlobalData } from '@/utils';
import { getArticleList } from '@/services/japi';

import FaqPage from '@/components/faq';
import { ArticleType } from '@/type/article';

interface IProps {
    articleList: ArticleType[];
}

const FAQ: React.FC<IProps> = (props) => {
    const { articleList } = props;

    return <FaqPage list={articleList} />;
};

export const getServerSideProps = withGlobalData(async (params: { locale: string; query: { blockId: string } }) => {
    const { locale, query } = params;
    const { blockId } = query || {};
    let articleList: ArticleType[] = [];
    try {
        const str = `?ids=${blockId}&page=1&page_size=200`;
        const res = await getArticleList(str, locale);
        const { state, data } = res;
        if (state === 1) {
            articleList = data?.list || [];
        }
    } catch (e) {
        articleList = [];
    }
    return { props: { articleList } };
});

export default FAQ;
